import { FC } from "react";
import classNames from "classnames";
import animation from "../../layout/OnboardingLayout.module.scss";
import styles from "./OrganizationPreview.module.scss";

export const OrganizationPreview: FC = () => (
    <div
        className={classNames(styles.organizationPreview, animation.fadeIn1)}
    />
);
